/**
 * SEO 默认TDK
 * @type {string}
 */
export const SEO = "SEO";

export const IMAGES_RENDER = "IMAGES_RENDER";

/**
 * CONFIG 网站UI结构
 * @type {string}
 */
export const CONFIGURATION = "CONFIGURATION";

export const HOME = {
  SEARCHHISTORY: "SEARCHHISTORY",
  SWITCHPRODUCTS: "SWITCHPRODUCTS",
  DEFAULTPRODUCTS: "DEFAULTPRODUCTS",
  DEFAULTMODULE: "DEFAULTMODULE",
  BRAND: "HOME.BRAND",
  SEARCH_TRIM: "HOME.SEARCH_TRIM",
  TOP_CAROUSEL: "HOME.TOP_CAROUSEL",
  TOP_MENU: "HOME.TOP_MENU",
  CATEGORY: "HOME.CATEGORY",
  CATEGORY_HOVER: "HOME.CATEGORY_HOVER",
  CATEGORY_SCROLL_TOP: "HOME.CATEGORY_SCROLL_TOP",
  FIXED_RIGHT_TOP: "HOME.FIXED_RIGHT_TOP",
  FIXED_RIGHT_BOTTOM: "HOME.FIXED_RIGHT_BOTTOM",
  FIXED_LEFT_CATEGORY: "HOME.FIXED_LEFT_CATEGORY",
  NAVIGATION_ALPHABET: "HOME.NAVIGATION_ALPHABET",
  // "SEARCH_INNER_VALUE":"HOME.SEARCH_INNER_VALUE",
  // "SEARCH_MYTIMER": "HOME.SEARCH_MYTIMER",
  // "SEARCH_INNER_PLACEHOLDER": "HOME.SEARCH_INNER_PLACEHOLDER",
  // "SEARCH_INNER_PLACEHOLDERS":'HOME.SEARCH_INNER_PLACEHOLDERS',
  PRESS_UP_DOWN_STATIC: "HOME.PRESS_UP_DOWN_STATIC",
  PRESS_UP_DOWN_FIXED: "HOME.PRESS_UP_DOWN_FIXED",

  SEARCH_MYTIMER_STATIC: "HOME.SEARCH_MYTIMER_STATIC",
  SEARCH_MYTIMER_FIXED: "HOME.SEARCH_MYTIMER_FIXED",
  SEARCH_INNER_PLACEHOLDER_STATIC: "HOME.SEARCH_INNER_PLACEHOLDER_STATIC",
  SEARCH_INNER_PLACEHOLDER_FIXED: "HOME.SEARCH_INNER_PLACEHOLDER_FIXED",
  SEARCH_INNER_PLACEHOLDERS_STATIC: "HOME.SEARCH_INNER_PLACEHOLDERS_STATIC",
  SEARCH_INNER_PLACEHOLDERS_FIXED: "HOME.SEARCH_INNER_PLACEHOLDERS_FIXED",

  SEARCH_RESULTS_STATIC: "HOME.SEARCH_RESULTS_STATIC",
  SEARCH_RESULTS_FIXED: "HOME.SEARCH_RESULTS_FIXED",
  SEARCH_RESULTS_DOWN: "HOME.SEARCH_RESULTS_DOWN",
  FIRSTORDERGIFT: "HOME.FIRSTORDERGIFT"
};
export const USER = {
  USER_TOKEN: "USER.USER_TOKEN",
  USER_CARDNUMBER: "USER.USER_CARDNUMBER",
  USER_PAYPOINTS: "USER.USER_PAYPOINTS",
  MINI_CART: "USER.MINI_CART",
  MINI_CART_NUM: "USER.MINI_CART_NUM",
  USER_NICKNAME: "USER.USER_NICKNAME",
  USER_CARDPOINTS: "USER.USER_CARDPOINTS",
  USER_CARDTYPE: "USER.USER_CARDTYPE",
  ERROR_CODE: "USER.ERROR_CODE",
  USER_SHIPPING_ADDRESS_LIST: "USER.USER_SHIPPING_ADDRESS_LIST",
};

export const GLOBAL = {
  HEIGHT: "GLOBAL.HEIGHT",
  WIDTH: "GLOBAL.WIDTH",
  SCROLL_TOP: "GLOBAL.SCROLL_TOP",
  SCROLL_BOTTOM: "GLOBAL.SCROLL_BOTTOM",
  PAGESHOW: "GLOBAL.PAGESHOW",
  CENTERMODEL: "GLOBAL.CENTERMODEL",
  BEAUTYHREF: "GLOBAL.BEAUTYHREF",
  TOPRIGHTMODEL: "GLOBAL.TOPRIGHTMODEL"
};

export const CHECKOUT = {
  CHECKOUT_ATTR_STATUS: "CHECKOUT.CHECKOUT_ATTR_STATUS",
  CHECKOUT_CUR_TYPE: "CHECKOUT.CHECKOUT_CUR_TYPE",
  CHECKOUT_CUR_STATUS: "CHECKOUT.CHECKOUT_CUR_STATUS",
  CHECKOUT_PHONE_STATUS: "CHECKOUT.CHECKOUT_PHONE_STATUS",
  CHECKOUT_ADDRESS_LIST: "CHECKOUT.CHECKOUT_ADDRESS_LIST",
  CHECKOUT_RESERVE_PROMOTION_DATA: "CHECKOUT.CHECKOUT_RESERVE_PROMOTION_DATA",
  CHECKOUT_MISS_SKUID_BOOKING: "CHECKOUT.CHECKOUT_MISS_SKUID_BOOKING",
  CHECKOUT_MISS_SKUID: "CHECKOUT.CHECKOUT_MISS_SKUID",
  CHECKOUT_ORDER_DETAILS: "CHECKOUT.CHECKOUT_ORDER_DETAILS",
  CHECKOUT_ALL_GIFT_BOOKING: "CHECKOUT.CHECKOUT_ALL_GIFT_BOOKING",
  CHECKOUT_ALL_GIFT: "CHECKOUT.CHECKOUT_ALL_GIFT",
  CHECKOUT_INPUTCOUPONS: "CHECKOUT.CHECKOUT_INPUTCOUPONS",
  CHECKOUT_PHONE_DATA: "CHECKOUT.CHECKOUT_PHONE_DATA",
  CHECKOUT_CHANGE_STATE: "CHECKOUT.CHECKOUT_CHANGE_STATE",
  SATISFYGIFTCOMMENTS:"SATISFYGIFTCOMMENTS",
  CHECKOUT_CHANGE_STATE_AGREEMENT: "CHECKOUT.CHECKOUT_CHANGE_STATE_AGREEMENT",

  CHECKOUT_GET: "CHECKOUT.CHECKOUT_GET",
  CHECKOUT_DEFAULT_ADDRESS: "CHECKOUT.CHECKOUT_DEFAULT_ADDRESS",
  CHECKOUT_ORDER_ID: "CHECKOUT.CHECKOUT_ORDER_ID",
  CHECKOUT_INFORMATION: "CHECKOUT.CHECKOUT_INFORMATION",
  CHECKOUT_CHANGE_PAYMENT: "CHECKOUT.CHECKOUT_CHANGE_PAYMENT",
  CHECKOUT_CHANGE_RECEIVING: "CHECKOUT.CHECKOUT_CHANGE_RECEIVING",
  CHECKOUT_PAY_LINK: "CHECKOUT.CHECKOUT_PAY_LINK",
  CHECKOUT_TAB: "CHECKOUT.CHECKOUT_TAB",

  CHECKOUT_TAB_GUESSYOULIKE: "CHECKOUT.CHECKOUT_TAB_GUESSYOULIKE",
  CHECKOUT_TAB_MYFAVORITE: "CHECKOUT.CHECKOUT_TAB_MYFAVORITE",
  CHECKOUT_TAB_MYBROWSERHISTORY: "CHECKOUT.CHECKOUT_TAB_MYBROWSERHISTORY",
  CHECKOUT_TAB_ACTIVE: "CHECKOUT.CHECKOUT_TAB_ACTIVE",

  CHECKOUT_ORDER_TYPE: "CHECKOUT.CHECKOUT_ORDER_TYPE",

  CHECKOUT_DELETE_POSITION_FIRST: "CHECKOUT.CHECKOUT_DELETE_POSITION_FIRST",
  CHECKOUT_DELETE_POSITION_SECOND: "CHECKOUT.CHECKOUT_DELETE_POSITION_SECOND",
  CHECKOUT_DELETE_POSITION_THIRD: "CHECKOUT.CHECKOUT_DELETE_POSITION_THIRD",

  CHECKOUT_DELIVERY_INFO: "CHECKOUT.CHECKOUT_DELIVERY_INFO",
  CHECKOUT_ADDRESS_COD: "CHECKOUT.CHECKOUT_ADDRESS_COD",
  CHECKOUT_ADDRESS_EXPRESS: "CHECKOUT.CHECKOUT_ADDRESS_EXPRESS",

  CHECKOUT_PURCHASED: "CHECKOUT.CHECKOUT_PURCHASED",
  CHECKOUT_CARTINFO: "CHECKOUT.CHECKOUT_CARTINFO",
  CHECKOUT_CARTINFO_BOOKING: "CHECKOUT.CHECKOUT_CARTINFO_BOOKING",

  CHECKOUT_CLOSE_ALERT: "CHECKOUT.CHECKOUT_CLOSE_ALERT",
  CHECKOUT_SAVE_ALERT_DATA: "CHECKOUT.CHECKOUT_SAVE_ALERT_DATA",
  CHECKOUT_NOTICE: "CHECKOUT.CHECKOUT_NOTICE",
  CHECKOUT_NOTICE_CLOSE: "CHECKOUT.CHECKOUT_NOTICE_CLOSE",
  CHECKOUT_NOTICE_OPEN_SUCCESS: "CHECKOUT.CHECKOUT_NOTICE_OPEN_SUCCESS",
  CHECKOUT_ADD_REMOVE: "CHECKOUT.CHECKOUT_ADD_REMOVE",
  CHECKOUT_CLOSE_DELETE: "CHECKOUT.CHECKOUT_CLOSE_DELETE",
  CHECKOUT_GET_SKU_STANDARD: "CHECKOUT.CHECKOUT_GET_SKU_STANDARD",
  CHECKOUT_SAVE_ALL_SKU: "CHECKOUT.CHECKOUT_SAVE_ALL_SKU",
  CHECKOUT_SAVE_TOTAL_DELETE: "CHECKOUT.CHECKOUT_SAVE_TOTAL_DELETE",
  CHECKOUT_COLLECT_ITEM_ALL: "CHECKOUT.CHECKOUT_COLLECT_ITEM_ALL",
  CHECKOUT_CLEAR_LOSE_SKU: "CHECKOUT.CHECKOUT_CLEAR_LOSE_SKU",
  CHECKOUT_ORDER_INFORMATION: "CHECKOUT.CHECKOUT_ORDER_INFORMATION",
  CHECKOUT_OPEN_THIRD_ALERT_PAY: "CHECKOUT.CHECKOUT_OPEN_THIRD_ALERT_PAY",
  CHECKOUT_CLOSE_THIRD_ALERT_PAY: "CHECKOUT.CHECKOUT_CLOSE_THIRD_ALERT_PAY",
  CHECKOUT_GET_ORDER_STATUS: "CHECKOUT.CHECKOUT_GET_ORDER_STATUS",
  CHECKOUT_CLEAR_SKU_STANDARD: "CHECKOUT.CHECKOUT_CLEAR_SKU_STANDARD",
  CHECKOUT_CLEAR_POSITION_DELETE: "CHECKOUT.CHECKOUT_CLEAR_POSITION_DELETE",
  PXCOUPONS: "CHECKOUT.PXCOUPONS",
  PROMOTIONCODEMAP: "CHECKOUT.PROMOTIONCODEMAP",
  ORDER_DETAIL: "CHECKOUT.ORDER_DETAIL", //MyAccount订单详情中已拆走，此处未删除，Hallie
  CHECKOUT_SELECT_TAB: "CHECKOUT.CHECKOUT_SELECT_TAB", //checkout  tab切换,
  CHECKOUT_SAVE_ALL_SKU_LOSE: "CHECKOUT.CHECKOUT_SAVE_ALL_SKU_LOSE", //获取失效商品信息列表
  CHECKOUT_MISS_SKUID: "CHECKOUT.CHECKOUT_MISS_SKUID", // 控制清除失效商品按钮,
  CHECKOUT_CORRESPOND_SKUID_BOOKING: "CHECKOUT.CHECKOUT_CORRESPOND_SKUID_BOOKING", //商品关联对应赠品数据(组增)
  CHECKOUT_CORRESPOND_SKUID: "CHECKOUT.CHECKOUT_CORRESPOND_SKUID", //商品关联对应赠品数据(组增)
  CHECKOUT_RESERVE_DATA: "CHECKOUT.CHECKOUT_RESERVE_DATA", //储存组增接口返回数据
  CHECKOUT_SINGLE_SKUID_BOOKING: "CHECKOUT.CHECKOUT_SINGLE_SKUID_BOOKING", //商品关联对应赠品数据(单增)
  CHECKOUT_SINGLE_SKUID: "CHECKOUT.CHECKOUT_SINGLE_SKUID", //商品关联对应赠品数据(单增)
  CHECKOUT_RESERVE_SINGLE_DATA: "CHECKOUT.CHECKOUT_RESERVE_SINGLE_DATA", //储存单增接口返回数据
  CHECKOUT_GOODS_STATUS: "CHECKOUT.CHECKOUT_GOODS_STATUS", //CART-- 记录定金预售商品状态
  CHECKOUT_SILK_CARD_LIST: "CHECKOUT.CHECKOUT_SILK_CARD_LIST", //存储丝享卡列表信息
  CHECKOUT_URL_PARMTER: "CHECKOUT.CHECKOUT_URL_PARMTER", //丝享卡支付入参
  CHECKOUT_SILK_PAY_ONOFF: "CHECKOUT.CHECKOUT_SILK_PAY_ONOFF", //SILK ON -OFF
  CHECKOUT_CHANGE_TAB_SORT: "CHECKOUT.CHECKOUT_CHANGE_TAB_SORT",
  CHECKOUT_CART_TIME_STAMP: "CHECKOUT.CHECKOUT_CART_TIME_STAMP",
  CHECKOUT_TIMEING_CHECKED: "CHECKOUT.CHECKOUT_TIMEING_CHECKED",
  CHECKOUT_REMEMBER_CHOOSE: "CHECKOUT.CHECKOUT_REMEMBER_CHOOSE",
  CHECKOUT_KEEP_PARAMETER: "CHECKOUT.CHECKOUT_KEEP_PARAMETER",
  CHECKOUT_SAVE_PARAMETER: "CHECKOUT.CHECKOUT_SAVE_PARAMETER",

  GETOPTIONALGIFT: "CHECKOUT.GETOPTIONALGIFT",

  CHECKOUT_INVOICE_STATUS: "CHECKOUT_INVOICE_STATUS", // 记录是否开具发票
  CHECKOUT_INVOICE_DEFAULTTITLE: "CHECKOUT_INVOICE_DEFAULTTITLE", // 存放默认抬头
  // "CHECKOUT_INVOICE_TYPE":"CHECKOUT_INVOICE_TYPE",// 抬头类型
  // "CHECKOUT_INVOICE_TITLE":"CHECKOUT_INVOICE_TITLE",// 抬头
  // "CHECKOUT_INVOICE_ISDEFAULTTITLE":"CHECKOUT_INVOICE_ISDEFAULTTITLE",//默认抬头
  CHECKOUT_INVOICE_INDIVIDUAL_SAVE: "CHECKOUT_INVOICE_INDIVIDUAL_SAVE", // 保存个人抬头

  // "CHECKOUT_INVOICE_ENTERPRISE_TAXNO":"CHECKOUT_INVOICE_ENTERPRISE_TAXNO",// 企业税号
  // "CHECKOUT_INVOICE_ENTERPRISE_BANK":"CHECKOUT_INVOICE_ENTERPRISE_BANK", // 开户银行
  // "CHECKOUT_INVOICE_ENTERPRISE_BANKACCOUNT":"CHECKOUT_INVOICE_BANKACCOUNT",// 银行账户
  // "CHECKOUT_INVOICE_ENTERPRISE_ADDRESS":"CHECKOUT_INVOICE_ENTERPRISE_ADDRESS",// 企业地址
  // "CHECKOUT_INVOICE_ENTERPRISE_TEL":"CHECKOUT_INVOICE_ENTERPRISE_TEL",// 企业电话
  CHECKOUT_INVOICE_ENTERPRISE_SAVE: "CHECKOUT_INVOICE_ENTERPRISE_SAVE", // 保存企业抬头
  CHECKOUT_INVOICE_ENTERPRISE_OPEN: "CHECKOUT_INVOICE_ENTERPRISE_OPEN", //展开选填

  CHECKOUT_INVOICE_TITLEID: "CHECKOUT_INVOICE_TITLEID", // 抬头id
  CHECKOUT_INVOICE_DATA: "CHECKOUT_INVOICE_DATA",
  DEPOSIT_COMMENT:"CHECKOUT.DEPOSIT_COMMENT", //定金预售备注
  SHOULDPAY:"CHECKOUT.SHOULDPAY",
  CANCEL_ORDER_TIME_LEFT:"CHECKOUT.CANCEL_ORDER_TIME_LEFT", //定金预售付尾款定金剩余时间, 后台返回
  CHECKOUT_AFTER_INFORMATION:"CHECKOUT_AFTER_INFORMATION",
  EXTRABUYACTID:"CHECKOUT.EXTRABUYACTID",//购物车换购id
  EXTRABUYTITLE:"CHECKOUT.EXTRABUYTITLE",//购物车换购title
  EXTRALBUYSHOWSTATUS:"CHECKOUT.EXTRALBUYSHOWSTATUS",
  EXCHANGEPRODUCTLIST:"CHECKOUT.EXCHANGEPRODUCTLIST", // 购物车换购商品
  CART_TIPSMSG: "CHECKOUT.CART_TIPSMSG", //因条件不再满足自动删除提示
  DELETEPRODUCTTYPE:"CHECKOUT.DELETEPRODUCTTYPE"
};

export const LOCATIONS = {
  LOCATIONS_PARAMS: "LOCATIONS.LOCATIONS_PARAMS",
  ORDER_DETAIL: "LOCATIONS.ORDER_DETAIL",
  LOGISTIC_INFO: "LOCATIONS.LOGISTIC_INFO",
  IS_SPLIT_PACKAGE: "LOCATIONS.IS_SPLIT_PACKAGE",
  AD_TEXT: "LOCATIONS.AD_TEXT",
};

export const ADDRESSPOPUP = {
  GET_POPUP_PROVINCE_PROTOTYPE: "ADDRESSPOPUP.GET_POPUP_PROVINCE_PROTOTYPE",
  OPEN_POPUP: "ADDRESSPOPUP.OPEN_POPUP",
  CLOSE_POPUP: "ADDRESSPOPUP.CLOSE_POPUP",
  OPEN_ADDRESS_LIST: "ADDRESSPOPUP.OPEN_ADDRESS_LIST",
  // "SET_POPUP_MODULE": 'POPUP.SET_POPUP_MODULE',
  // "SET_POPUP_STATE": 'POPUP.SET_POPUP_STATE',

  // "GET_POPUP_PROVINCE_LIST": 'POPUP.GET_POPUP_PROVINCE_LIST',
  // "GET_POPUP_PROVINCE_COD": 'POPUP.GET_POPUP_PROVINCE_COD',

  // "GET_POPUP_CITY_PROTOTYPE": 'POPUP.GET_POPUP_CITY_PROTOTYPE',
  // "GET_POPUP_CITY_LIST": 'POPUP.GET_POPUP_CITY_LIST',
  // "GET_POPUP_CITY_COD": 'POPUP.GET_POPUP_CITY_COD',

  // "GET_POPUP_AREA_PROTOTYPE": 'POPUP.GET_POPUP_AREA_PROTOTYPE',
  // "GET_POPUP_AREA_LIST": 'POPUP.GET_POPUP_AREA_LIST',
  // "GET_POPUP_AREA_COD": 'POPUP.GET_POPUP_AREA_COD',

  // "SET_POPUP_PROVINCE_CHANGE_PROVINCE": 'POPUP.SET_POPUP_PROVINCE_CHANGE_PROVINCE',
  // "SET_POPUP_PROVINCE_CHANGE_CITY": 'POPUP.SET_POPUP_PROVINCE_CHANGE_CITY',
  // "SET_POPUP_PROVINCE_CHANGE_AREA": 'POPUP.SET_POPUP_PROVINCE_CHANGE_AREA',

  // "SET_POPUP_PROVINCE_ADDRESS_IS_DEFAULT": 'POPUP.SET_POPUP_PROVINCE_ADDRESS_IS_DEFAULT',
  // "SET_POPUP_PROVINCE_ZIP_CODE": 'POPUP.SET_POPUP_PROVINCE_ZIP_CODE',
  // "SET_POPUP_PROVINCE_USER_NAME": 'POPUP.SET_POPUP_PROVINCE_USER_NAME',
  // "SET_POPUP_PROVINCE_ADDRESS_DETAIL": 'POPUP.SET_POPUP_PROVINCE_ADDRESS_DETAIL',
  // "SET_POPUP_PROVINCE_COD": 'POPUP.SET_POPUP_PROVINCE_COD',
  // "SET_POPUP_PROVINCE_TELEPHONE": 'POPUP.SET_POPUP_PROVINCE_TELEPHONE',
  // "SET_POPUP_PROVINCE_MOBILE_PHONE": 'POPUP.SET_POPUP_PROVINCE_MOBILE_PHONE',

  // "GET_POPUP_PROTOTYPE_ADDRESS_DETAIL": 'POPUP.GET_POPUP_PROTOTYPE_ADDRESS_DETAIL',
  // "GET_POPUP_PROTOTYPE_ADDRESS_ID": 'POPUP.GET_POPUP_PROTOTYPE_ADDRESS_ID',

  // "CLEAR_POPUP_ITEMS": 'POPUP.CLEAR_POPUP_ITEMS'
};

export const CATEGORY = {
  FILTER_STATUS: "CATEGORY.FILTER_STATUS", // v
  TOGGLE_SHOW_ALL: "CATEGORY.TOGGLE_SHOW_ALL", // v
  CONTROL_BOTTOM: "CATEGORY.CONTROL_BOTTOM", // v
  GET_BRANDS: "CATEGORY.GET_BRANDS", //v
  SAVE_VALUE: "CATEGORY.SAVE_VALUE", //v

  POPUP_REQUEST: "CATEGORY.POPUP_REQUEST", // v
  CATEGORY_POPUP: "CATEGORY.CATEGORY_POPUP", // v
  POPUP_ORDER_NUM: "CATEGORY.POPUP_ORDER_NUM", // v
  HIDE_FIXED_TOP: "CATEGORY.HIDE_FIXED_TOP", // v
  LACK_INV: "CATEGORY.LACK_INV", // v
  SHOW_SUCCESS: "CATEGORY.SHOW_SUCCESS", // v
  GETADBANNER: "CATEGORY.GETADBANNER", // v

  // "SELECT_SINGLE" : "CATEGORY.SELECT_SINGLE",
  // "TOGGLE_LIST_ITEM" : "CATEGORY.TOGGLE_LIST_ITEM",
  // "ADD_LIST_ITEM_STATUS" : "CATEGORY.ADD_LIST_ITEM_STATUS",
  // "ADD_SELECT_MORE_STATUS" : "CATEGORY.ADD_SELECT_MORE_STATUS",
  // "ADD_SHOW_MORE_STATUS" : "CATEGORY.ADD_SHOW_MORE_STATUS" ,
  // "SHOW_MORE" : "CATEGORY.SHOW_MORE",
  // "SELECT_MORE" : "CATEGORY.SELECT_MORE",
  // "CANCEL_SELECT_MORE" : "CATEGORY.CANCEL_SELECT_MORE",
  // "DROP_MENU" : "CATEGORY.DROP_MENU",
  // "LIFT_MENU" : "CATEGORY.LIFT_MENU",
  // "ADD_BRAND" : "CATEGORY.ADD_BRAND",
  // "TOGGLE_ONE_BRAND" : "CATEGORY.TOGGLE_ONE_BRAND",
  // "REMOVE_SELECTED" : "CATEGORY.REMOVE_SELECTED",
  // "DELETE_ALL_BRAND" : "CATEGORY.DELETE_ALL_BRAND",
  // "CONFIRM_SELECT_BRAND" : "CATEGORY.CONFIRM_SELECT_BRAND",
  // "SHOW_MORE_CATEGORY_LIST" : "CATEGORY.SHOW_MORE_CATEGORY_LIST",
  // "CHANGE_LIST_BOTTOM" : "CATEGORY.CHANGE_LIST_BOTTOM",
  SORT_PRODUCT: "CATEGORY.SORT_PRODUCT",
  // "SHOW_BUY_NOW" : "CATEGORY.SHOW_BUY_NOW",
  // "HIDE_BUY_NOW" : "CATEGORY.HIDE_BUY_NOW",
  // "CLOESE_POPUP" : "CATEGORY.CLOESE_POPUP",
  // "SAVE_LEFT_VALUE" : "CATEGORY.SAVE_LEFT_VALUE",
  SET_OFFSETTOP: "CATEGORY.SET_OFFSETTOP",
  IFSHOW: "CATEGORY.IFSHOW",
};

export const BRANDWALL = {
  GET_BRAND_WALL_INFO: "BRANDWALL.GET_BRAND_WALL_INFO",
  SET_OFFSETTOP: "BRANDWALL.SET_OFFSETTOP",
  SET_TOP: "BRANDWALL.SET_TOP",
  CHANGE_CURRENT_LETTER_BG: "BRANDWALL.CHANGE_CURRENT_LETTER_BG",

  GET_AD_IMG: "BRANDWALL.GET_AD_IMG",
  GET_AD_TEXT: "BRANDWALL.GET_AD_TEXT",
  SET_HOT_BRAND_OFFSETTOP: "BRANDWALL.SET_HOT_BRAND_OFFSETTOP",
  // 'BRAND_STORY_LINK' : 'BRANDWALL.BRAND_STORY_LINK'
};

/**
 * 所有同步模块异步化数据入口
 * @type {{GET_SEARCH_PLACEHOLDER: string, GET_SEARCH_HOT_WORLD: string, GET_NAVIGATION_GROUP: string, GET_NAVIGATION_BRAND_GROUP: string}}
 */
export const ASYNC = {
  GET_SEARCH_PLACEHOLDER: "ASYNC.GET_SEARCH_PLACEHOLDER",
  GET_SEARCH_HOT_WORLD: "ASYNC.GET_SEARCH_HOT_WORLD",
  GET_NAVIGATION_GROUP: "ASYNC.GET_NAVIGATION_GROUP",
  GET_NAVIGATION_BRAND_GROUP: "ASYNC.GET_NAVIGATION_BRAND_GROUP",
};

/**
 * 弹出层 => 组件类
 * @type {{POPUP_STATE: string}}
 */
export const POPUP_COMPONENT = {
  POPUP_STATE: "POPUP_COMPONENT.POPUP_STATE",
  POPUP_MODULE: "POPUP_COMPONENT.POPUP_MODULE",

  POPUP_PUBLIC_STEP: "POPUP_COMPONENT.POPUP_PUBLIC_STEP",
  POPUP_PUBLIC_KEY: "POPUP_COMPONENT.POPUP_PUBLIC_KEY",
  POPUP_PUBLIC_CALLBACK: "POPUP_COMPONENT.POPUP_PUBLIC_CALLBACK",
};

/**
 * 弹出层 => 组件类 -- V2
 * @type {{POPUP_STATE: string}}
 */
export const POPUP_ADDRESS = {
  POPUP_STATE: "POPUP_ADDRESS.POPUP_STATE",
  POPUP_MODULE: "POPUP_ADDRESS.POPUP_MODULE",
};

/**
 * 弹出层 => 提示类
 * @type {{POPUP_STATE: string}}
 */
export const POPUP_ALERT = {
  POPUP_STATE: "POPUP_ALERT.POPUP_STATE",
  POPUP_MODULE: "POPUP_ALERT.POPUP_MODULE",
};

export const DATA = {
  DATA_ADDRESS_PROVINCE: "DATA.DATA_ADDRESS_PROVINCE",
};

/*
 * MYACCOUNT_ORDER
 */
export const MY_ORDER = {
  MY_ORDER_NOW_YEAR: "MY_ORDER.MY_ORDER_NOW_YEAR",
  MY_ORDER_STATUS_TYPE_MODULE: "MY_ORDER.MY_ORDER_STATUS_TYPE_MODULE",
  MY_ORDER_NOW_TIME_VALUE_CODE: "MY_ORDER.MY_ORDER_NOW_TIME_VALUE_CODE",
  MY_ORDER_NOW_STATUS_CODE: "MY_ORDER.MY_ORDER_NOW_STATUS_CODE",
  MY_ORDER_PAGE_CURRENT: "MY_ORDER.MY_ORDER_PAGE_CURRENT",
  MY_ORDER_PAGE_TOTAL: "MY_ORDER.MY_ORDER_PAGE_TOTAL",
  MY_ORDER_LIST_MODULE: "MY_ORDER.MY_ORDER_LIST_MODULE",
  MY_ORDER_SHOW_COMMENTS: "MY_ORDER.MY_ORDER_SHOW_COMMENTS",
  MY_ORDER_HISTORY: "MY_ORDER.MY_ORDER_HISTORY",
  MY_ORDER_NEW_TIME: "MY_ORDER.MY_ORDER_NEW_TIME",
  MY_ORDER_NEW_STATUS: "MY_ORDER.MY_ORDER_NEW_STATUS",
  MY_ORDER_NEW_TAB: "MY_ORDER.MY_ORDER_NEW_TAB",
  MY_ORDER_NOW_TIME_VALUE: "MY_ORDER.MY_ORDER_NOW_TIME_VALUE",
  MY_ORDER_TIME_MODULE_SHOW: "MY_ORDER.MY_ORDER_TIME_MODULE_SHOW",
  MY_ORDER_STATUS_MODULE_SHOW: "MY_ORDER.MY_ORDER_STATUS_MODULE_SHOW",
  MY_ORDER_STATUS_TYPE: "MY_ORDER.MY_ORDER_STATUS_TYPE",
  MY_ORDER_NOW_STATUS_VALUE: "MY_ORDER.MY_ORDER_NOW_STATUS_VALUE",
  MY_ORDER_COMMENTS_NOW_OP: "MY_ORDER.MY_ORDER_COMMENTS_NOW_OP",
  MY_ORDER_COMMENTS_NOW_ORDER_ID: "MY_ORDER.MY_ORDER_COMMENTS_NOW_ORDER_ID",
  MY_ORDER_COMMENTS_NOW_SKUID: "MY_ORDER.MY_ORDER_COMMENTS_NOW_SKUID",
  MY_ORDER_NOW_PAY_ORDER_ID: "MY_ORDER.MY_ORDER_NOW_PAY_ORDER_ID",
  MY_ORDER_NOW_PAY_MONEY: "MY_ORDER.MY_ORDER_NOW_PAY_MONEY",
  MY_ORDER_DOWN_PAY_BOX_SHOW: "MY_ORDER.MY_ORDER_DOWN_PAY_BOX_SHOW",
  MY_ORDER_CANCEL_REASON_STATUS: "MY_ORDER.MY_ORDER_CANCEL_REASON_STATUS",
  MY_ORDER_CANCEL_REASON_SHOW: "MY_ORDER.MY_ORDER_CANCEL_REASON_SHOW",
  MY_ORDER_CANCEL_REASON_LIST: "MY_ORDER.MY_ORDER_CANCEL_REASON_LIST",
  MY_ORDER_CANCEL_REASON_TYPE: "MY_ORDER.MY_ORDER_CANCEL_REASON_TYPE",
  MY_ORDER_ORDER_ID: "MY_ORDER.MY_ORDER_ORDER_ID",
  MY_ORDER_LOGISTIC_SHOW: "MY_ORDER.MY_ORDER_LOGISTIC_SHOW",
  MY_ORDER_LOGISTIC_MODEL: "MY_ORDER.MY_ORDER_LOGISTIC_MODEL",
  MY_ORDER_LOGISTIC_INDEX: "MY_ORDER.MY_ORDER_LOGISTIC_INDEX",
  PAY_TOGETHER_POPUP_TOOGLE:"MY_ORDER.PAY_TOGETHER_POPUP_TOOGLE",  //合并支付pop开关 
  MERGE_ORDERS:"MY_ORDER.MERGE_ORDERS",//合并支付的订单
  MY_ORDER_ORDER_CHECK:"MY_ORDER.MY_ORDER_ORDER_CHECK",//定金预售时, 选中订单号
 
};

/*
 * MYACCOUNT_ONLINE_RETURN
 */
export const MY_ONLINE_RETURN = {
  MY_ONLINE_RETURN_NOW_YEAR: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_YEAR",
  MY_ONLINE_RETURN_STATUS_TYPE_MODULE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_TYPE_MODULE",
  MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE",
  MY_ONLINE_RETURN_NOW_STATUS_CODE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_STATUS_CODE",
  MY_ONLINE_RETURN_PAGE_CURRENT: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_PAGE_CURRENT",
  MY_ONLINE_RETURN_PAGE_TOTAL: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_PAGE_TOTAL",
  MY_ONLINE_RETURN_LIST_MODULE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_LIST_MODULE",
  MY_ONLINE_RETURN_SHOW_COMMENTS: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_SHOW_COMMENTS",
  MY_ONLINE_RETURN_HISTORY: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_HISTORY",
  MY_ONLINE_RETURN_NEW_TIME: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_TIME",
  MY_ONLINE_RETURN_NEW_STATUS: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_STATUS",
  MY_ONLINE_RETURN_NEW_TAB: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_TAB",
  MY_ONLINE_RETURN_NOW_TIME_VALUE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_TIME_VALUE",
  MY_ONLINE_RETURN_TIME_MODULE_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_TIME_MODULE_SHOW",
  MY_ONLINE_RETURN_STATUS_MODULE_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_MODULE_SHOW",
  MY_ONLINE_RETURN_STATUS_TYPE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_TYPE",
  MY_ONLINE_RETURN_NOW_STATUS_VALUE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_STATUS_VALUE",
  MY_ONLINE_RETURN_COMMENTS_NOW_OP: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_COMMENTS_NOW_OP",
  MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID",
  MY_ONLINE_RETURN_COMMENTS_NOW_SKUID: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_COMMENTS_NOW_SKUID",
  MY_ONLINE_RETURN_NOW_PAY_ORDER_ID: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_PAY_ORDER_ID",
  MY_ONLINE_RETURN_NOW_PAY_MONEY: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_PAY_MONEY",
  MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW",
  MY_ONLINE_RETURN_CANCEL_REASON_STATUS: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_CANCEL_REASON_STATUS",
  MY_ONLINE_RETURN_CANCEL_REASON_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_CANCEL_REASON_SHOW",
  MY_ONLINE_RETURN_ORDER_ID: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_ORDER_ID",
  MY_ONLINE_RETURN_LOGISTIC_SHOW: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_LOGISTIC_SHOW",
  MY_ONLINE_RETURN_LOGISTIC_MODEL: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_LOGISTIC_MODEL",
  MY_ONLINE_RETURN_LOGISTIC_INDEX: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_LOGISTIC_INDEX",
  MY_ONLINE_RETURN_USER_PROFILE: "MY_ONLINE_RETURN.MY_ONLINE_RETURN_USER_PROFILE",
};

/*
 * PDP所有需要的数据参数
 * */
export const PDP = {
  PRODUCT_DETAIL_ERROR: "PDP.PRODUCT_DETAIL_ERROR",
  PRODUCT_DETAIL_MAIN: "PDP.PRODUCT_DETAIL_MAIN",
  PRODUCT_SKU_DETAIL_INFO: "PDP.PRODUCT_SKU_DETAIL_INFO",
  PRODUCT_SKU_HTML: "PDP.PRODUCT_SKU_HTML",
  PRODUCT_DETAIL_IMAGE: "PDP.PRODUCT_DETAIL_IMAGE",
  PRODUCT_DETAIL_IMAGE_NOW: "PDP.PRODUCT_DETAIL_NOW",
  PRODUCT_DETAIL_IMAGE_NOW_TAG: "PDP.PRODUCT_DETAIL_IMAGE_NOW_TAG",

  PRODUCT_DETAIL_IMAGE_NOW_INDEX: "PDP.Magnifier_NOW_INDEX",
  PRODUCT_BREADCRUMB: "PDP.PRODUCT_BREADCRUMB",
  PRODUCT_QA_LIST: "PDP.PRODUCT_QA_LIST",
  PRODUCT_QA_LIST_PAGE: "PDP.PRODUCT_QA_LIST_PAGE",
  PRODUCT_COLLOCATION: "PDP.PRODUCT_COLLOCATION",
  PRODUCT_COMMENTS_LIST: "PDP.PRODUCT_COMMENTS_LIST",
  PRODUCT_COMMENTS_LIST_PAGE: "PDP.PRODUCT_COMMENTS_LIST_PAGE",
  PRODUCT_USER_BUY_ONE_YEAR: "PDP.PRODUCT_USER_BUY_ONE_YEAR",
  PRODUCT_SKU_PROMOTION_INFO: "PDP.PRODUCT_SKU_PROMOTION_INFO",
  PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE: "PDP.PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE",
  PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE: "PDP.PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE",
  PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE:
    "PDP.PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE",
  PRODUCT_AD_GUESS: "PDP.PRODUCT_AD_GUESS",
  PRODUCT_AD_MAIN: "PDP.PRODUCT_AD_MAIN",
  PRODUCT_INVENTORY: "PDP.PRODUCT_INVENTORY",
  PRODUCT_GUESS_LIKE: "PDP.PRODUCT_GUESS_LIKE",
  PRODUCT_HTML_DOM: "PDP.PRODUCT_HTML_DOM",
  PRODUCT_COLOR_ITEM: "PDP.PRODUCT_COLOR_ITEM",
  PRODUCT_COLOR_GATHER: "PDP.PRODUCT_COLOR_GATHER",
  PRODUCT_COLOR_NESTED_INFO: "PDP.PRODUCT_COLOR_NESTED_INFO",
  PRODUCT_CHARACTER_ITEM: "PDP.PRODUCT_CHARACTER_ITEM",
  PRODUCT_SAVE_DATA: "PDP.PRODUCT_SAVE_DATA",
  PRODUCT_SAVE_DEFULT_SKUID: "PDP.PRODUCT_SAVE_DEFULT_SKUID",
  PRODUCT_CHARACTER_LIST: "PDP.PRODUCT_CHARACTER_LIST",
  PRODUCT_SAVE_END_DATA: "PDP.PRODUCT_SAVE_END_DATA",
  PRODUCT_FILTER_CONDITION_DATA: "PRODUCT_FILTER_CONDITION_DATA",
  PRODUCT_FILTER_CONDITION_CHARACTER_DATA: "PRODUCT_FILTER_CONDITION_CHARACTER_DATA",
  PRODUCT_STORAGE_COUNT: "PRODUCT_STORAGE_COUNT",
  PRODUCT_BOOKING_STAUTUS: "PRODUCT_BOOKING_STAUTUS",
  PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK: "PDP.PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK",
  PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA",
  PRODUCT_SKU_PROMOTION_INFO_GIFT_ID: "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_ID",
  PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX:
    "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX",
  PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX:
    "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX",
  PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX:
    "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX",
  PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX:
    "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX",
  PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX:
    "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX",
  PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY:
    "PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY",
  PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME:
    "PDP.PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME",
  PRODUCT_GUERLAIN_ROUGE_OFFSET: "PDP.PRODUCT_GUERLAIN_ROUGE_OFFSET",
  PRODUCT_GUERLAIN_ENTER: "PDP.PRODUCT_GUERLAIN_ENTER",
  PRODUCT_GUERLAIN_INFO: "PDP.PRODUCT_GUERLAIN_INFO",
  PRODUCT_GUERLAIN_INFO_URL: "PDP.PRODUCT_GUERLAIN_INFO_URL",
  PRODUCT_GUERLAIN_INFO_CAP: "PDP.PRODUCT_GUERLAIN_INFO_CAP",
  PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON: "PDP.PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON",
  PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON: "PDP.PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON",
  PRODUCT_MIUMIU_INFO: "PDP.PRODUCT_MIUMIU_INFO", //miumiu数据源
  PRODUCT_MIUMIU_INFO_URL: "PDP.PRODUCT_MIUMIU_INFO_URL", //miumiu香水路由
  PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON: "PDP.PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON",
  PRODUCT_MIUMIU_INFO_CAP_PITCH_ON: "PDP.PRODUCT_MIUMIU_INFO_CAP_PITCH_ON",
  PRODUCT_MIUMIU_INFO_TWO: "PDP.PRODUCT_MIUMIU_INFO_TWO",
  PRODUCT_MIUMIU_INFO_THREE: "PDP.PRODUCT_MIUMIU_INFO_THREE",
  PRODUCT_MIUMIU_INFO_LID_ON:"PDP.PRODUCT_MIUMIU_INFO_LID_ON",
  PRODUCT_MIUMIU_INFO_BODY_ON:"PDP.PRODUCT_MIUMIU_INFO_BODY_ON",
  PRODUCT_MIUMIU_ENTER:"PDP.PRODUCT_MIUMIU_ENTER",
  
  PRODUCT_SKU_PROMOTION_INFO_GWP: "PDP.PRODUCT_SKU_PROMOTION_INFO_GWP",
  PRODUCT_VB_GIFT_LIST: "PDP.PRODUCT_VB_GIFT_LIST",
  PRODUCT_SKU_PROMOTION_INFO_THE_POSTS: "PDP.PRODUCT_SKU_PROMOTION_INFO_THE_POSTS",

  PRODUCT_POSTS_LIST: "PDP.PRODUCT_POSTS_LIST",
  PRODUCT_POSTS_LIST_PAGE: "PDP.PRODUCT_POSTS_LIST_PAGE",

  PRODUCT_COMMENTS_REASON: "PDP.PRODUCT_COMMENTS_REASON",

  PRODUCT_COMMENTS_SWITCH: "PDP.PRODUCT_COMMENTS_SWITCH",
  PRODUCT_GET_STANDING: "PRODUCT_GET_STANDING",
};

/*
 * 我的QA
 * */
export const MY_QA = {
  MY_QA_LIST_PAGE: "PDP.MY_QA_LIST_PAGE",
};

/*
 * myAccount-address
 * */
export const MY_AD = {
  MY_AD_LISTS: "MY_AD.MY_AD_LISTS",
  MY_AD_DEFAULT: "MY_AD.MY_AD_DEFAULT",
};

export const MY_COUPON = {
  MY_COUPON_RESULTS: "MY_COUPON.MY_COUPON_RESULTS",
  MY_COUPON_LISTS: "MY_COUPON.MY_COUPON_LISTS",
};

/*
 * CATEGORYONELEVEL所有需要的数据参数
 * */

export const CATEGORYONELEVEL = {
  GET_AD_IMG: "CATEGORYONELEVEL.GET_AD_IMG",
  GET_CRUMBS: "CATEGORYONELEVEL.GET_CRUMBS",
  GET_PATH: "CATEGORYONELEVEL.GET_PATH",
  GET_CONTENTS: "CATEGORYONELEVEL.GET_CONTENTS",
};

/*
 * Campaign data
 * */
export const CAMPAIGN = {
  GET_CAMPAIGN_HTML: "CAMPAIGN.GET_CAMPAIGN_HTML",
  GET_CAMPAIGN_NAME: "CAMPAIGN.GET_CAMPAIGN_NAME",
};

/*
 * Content data
 * */
export const CONTENT = {
  GET_CONTENT_HTML: "CONTENT.GET_CONTENT_HTML",
  GET_CONTENT_NAME: "CONTENT.GET_CONTENT_NAME",
};

/*
 * 门店会员首次登录
 * */
export const LOGIN_MEMBER = {
  LOGIN_MEMBER_RESULTS: "LOGIN_MEMBER.LOGIN_MEMBER_RESULTS",
  LOGIN_MEMBER_UI: "LOGIN_MEMBER.LOGIN_MEMBER_UI",
};

/*
 * GA
 * */
export const GA = {
  GA_DATA: "GA.GA_DATA",
  GA_DATA_PAGE: "GA.GA_DATA_PAGE",
  USER: "GA.USER",
};

export const EMARSYS = {
  SAVE_DATA_STATUS: "EMARSYS.SAVE_DATA_STATUS",
};

export const DEPENDENCY = {
  GOOGLE_ANALYTICS: "DEPENDENCY.GOOGLE_ANALYTICS",
  SENSOR: "DEPENDENCY.SENSOR",
};

export const NICHEFRAGRANCE = {
  // "CAROUSEL_ORDER": "NICHEFRAGRANCE.CAROUSEL_ORDER",
  // "ENTRANCPRELOADED": "NICHEFRAGRANCE.ENTRANCPRELOADED",
  // "CURRENTBRANDPRELOADED": "NICHEFRAGRANCE.CURRENTBRANDPRELOADED",
  // "CURRENT_SCENE": "NICHEFRAGRANCE.CURRENT_SCENE",
  PRELOADSTATUS: "NICHEFRAGRANCE.PRELOADSTATUS",
  SCENESTATUS: "NICHEFRAGRANCE.SCENESTATUS",

  MORE_PRODUCTS: "NICHEFRAGRANCE.MORE_PRODUCTS",
  MYSOURCEDATA: "NICHEFRAGRANCE.MYSOURCEDATA",
  MYVIDEO: "NICHEFRAGRANCE.MYVIDEO",
  DRAWER: "NICHEFRAGRANCE.DRAWER",
  PAGINATION: "NICHEFRAGRANCE.PAGINATION",
};

export const PURCHASERECORD = {
  PURCHASERECORD: "PURCHASERECORD.PURCHASERECORD",
};

export const ONLINERETURN = {
  RETURN_APPLY: "ONLINERETURN.RETURN_APPLY",
  RETURN_INFO: "ONLINERETURN.RETURN_INFO",
  RETURN_PAY_INFO: "ONLINERETURN.RETURN_PAY_INFO",
  ORDER_PRD_DETAIL: "ONLINERETURN.ORDER_PRD_DETAIL",
};

export const MESSAGECENTER = {
  MESSAGECENTER_TYPE: "MESSAGECENTER_TYPE",
  PAGINATION_TOTAL: "PAGINATION_TOTAL",
  PAGINATION_CURRENT: "PAGINATION_CURRENT",
  MYMESSAGE_DATASOURCE: "MYMESSAGE_DATASOURCE",
  INFO_DATASOURCE: "INFO_DATASOURCE",
  HASNEWMESSAGE: "HASNEWMESSAGE",
  HASNEWINFO: "HASNEWINFO",
};

export const INVOICELIST = {
  INVOICELIST_DATASOURCE: "INVOICELIST_DATASOURCE",
};

export const ISSUEINVOICE = {
  DEFAULTTITLEDATA: "ISSUEINVOICE_DEFAULTTITLEDATA",
  INVOICEDATA: "ISSUEINVOICE_INVOICEDATA",
  INVOICEMSG: "ISSUEINVOICE_INVOICEMSG",
};



// WEBPACK FOOTER //
// ./common/constants/ActionTypes.js